import React, { Component } from 'react'
import { revenuecostService } from '../../Services/revenuecostService'

class QuickbookAuth extends Component {
    
    componentDidMount() {
        this.signInIntuit()
    }

    signInIntuit = () => {
        revenuecostService.qbookAuth().then(result => {
            if(!result.status){
              window.location.href = result.uri
            }
        })
    }

    render() {
       
        return (
            <>Checking Auth...</>
        )
    }
}

export { QuickbookAuth }